import type { FC } from "react";

import dompurify from "isomorphic-dompurify";

import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { Card } from "@jti/core-components/components/Card";

import styles from "./OneTrustErrorBanner.module.scss";

const { sanitize } = dompurify;

type OneTrustErrorBannerProps = {
  redirectUrl?: string;
  linkText?: string;
  title?: string;
  errorMessage: string;
};

export const OneTrustErrorBanner: FC<OneTrustErrorBannerProps> = ({ redirectUrl, linkText, errorMessage, title }) => {
  return (
    <div className={styles.wrapper}>
      <Card variant="level-1" title={title}>
        <AlertBanner
          tone="error"
          actions={
            redirectUrl && linkText
              ? [
                  {
                    href: redirectUrl,
                    label: linkText,
                    nativeBehaviour: true,
                  },
                ]
              : undefined
          }
          richDescription={
            <div
              dangerouslySetInnerHTML={{
                __html: sanitize(errorMessage),
              }}
            />
          }
        />
      </Card>
    </div>
  );
};
